import { render } from "./ui-company-document-file.vue?vue&type=template&id=4e9da82a&ts=true"
import script from "./ui-company-document-file.vue?vue&type=script&lang=ts"
export * from "./ui-company-document-file.vue?vue&type=script&lang=ts"

import "./ui-company-document-file.vue?vue&type=style&index=0&id=4e9da82a&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__